import React from 'react';
import {
  Box, Grid, Paper, Typography, Divider, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Avatar
} from '@mui/material';
import {
  TrendingUp, AttachMoney, Inventory, Warning
} from '@mui/icons-material';

const Dashboard = () => {
  const summary = [
    { icon: <Inventory color="primary" />, label: "Total Items Tracked", value: 120 },
    { icon: <Warning color="error" />, label: "Out of Stock Items", value: 8 },
    { icon: <Warning color="warning" />, label: "Low Stock Items", value: 15 },
    { icon: <TrendingUp color="info" />, label: "Sales Today", value: 145 },
    { icon: <AttachMoney color="secondary" />, label: "Revenue (RM)", value: 1345.80 }
  ];

  const transactions = [
    { time: "10:12 AM", item: "Coca Cola", status: "Paid", amount: "2.50" },
    { time: "10:08 AM", item: "Mineral Water", status: "Paid", amount: "1.80" },
    { time: "10:03 AM", item: "KitKat", status: "Cancelled", amount: "0.00" },
    { time: "09:58 AM", item: "Snickers", status: "Paid", amount: "2.80" },
    { time: "09:45 AM", item: "Pepsi", status: "Timeout", amount: "0.00" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Operations & Sales Dashboard</Typography>

      {/* Summary Cards */}
      <Grid container spacing={3}>
        {summary.map((card, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Paper elevation={3} sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
              <Avatar sx={{ bgcolor: 'primary.light', mr: 2 }}>
                {card.icon}
              </Avatar>
              <Box>
                <Typography variant="subtitle2">{card.label}</Typography>
                <Typography variant="h6">{card.value}</Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Charts Placeholder */}
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Typography variant="h6">Sales by Hour</Typography>
            <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="body2" color="text.secondary">[Chart Placeholder]</Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Typography variant="h6">Stock Status Breakdown</Typography>
            <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="body2" color="text.secondary">[Pie Chart Placeholder]</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Recent Transactions Table */}
      <Paper sx={{ mt: 4, p: 2 }}>
        <Typography variant="h6" gutterBottom>Recent Transactions</Typography>
        <Divider sx={{ mb: 2 }} />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Amount (RM)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((tx, idx) => (
                <TableRow key={idx}>
                  <TableCell>{tx.time}</TableCell>
                  <TableCell>{tx.item}</TableCell>
                  <TableCell>
                    <Typography color={tx.status === "Paid" ? "green" : tx.status === "Cancelled" ? "orange" : "red"}>
                      {tx.status}
                    </Typography>
                  </TableCell>
                  <TableCell>{tx.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Dashboard;
